/**
 * IKEA PDP-style short line: "{typeName}, {variant from URL}, {measurement}".
 * Mirrors sicily-backend/lib/ikeaCatalogSubtitle.js for client-side product views.
 */

function slugifyIkeaSegment(text) {
  if (!text || typeof text !== 'string') return '';
  return text
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function extractPathSlugFromIkeaUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const m = url.match(/\/p\/([^/?#]+)-(\d{6,})\/?(?:[#?].*)?$/i);
  return m ? String(m[1] || '').trim() : '';
}

function typeSlugTokens(typeName) {
  const slug = slugifyIkeaSegment(typeName);
  if (!slug) return [];
  return slug.split('-').filter(Boolean);
}

function findTypeSpan(tokens, typeToks) {
  if (typeToks.length === 0 || tokens.length < typeToks.length) return -1;
  outer:
  for (let i = 0; i <= tokens.length - typeToks.length; i++) {
    for (let j = 0; j < typeToks.length; j++) {
      if (tokens[i + j] !== typeToks[j]) continue outer;
    }
    return i;
  }
  return -1;
}

function variantDescriptorFromUrl(product) {
  const url = product.url || product.url_en || '';
  const pathSlug = extractPathSlugFromIkeaUrl(url);
  if (!pathSlug) return '';
  const tokens = pathSlug.split('-').filter(Boolean);
  const typeName = product.typeName || product.typeName_en || '';
  const typeToks = typeSlugTokens(typeName);
  const i = findTypeSpan(tokens, typeToks);
  if (i < 0) return '';
  const after = tokens.slice(i + typeToks.length);
  if (after.length === 0) return '';
  return after.join(' ');
}

export function ikeaCatalogSubtitle(product) {
  if (!product || typeof product !== 'object') return '';
  const typeName = String(product.typeName || product.typeName_en || '').trim();
  const measurement = String(product.measurement || product.measurement_en || '').trim();
  const variant = variantDescriptorFromUrl(product).trim();
  const parts = [typeName, variant, measurement].filter(Boolean);
  return parts.join(', ');
}

/**
 * Short line for grids and cards: PDP-style subtitle when possible, else legacy imageAlt tail after name.
 */
export function productListingSubtitle(product) {
  if (!product || typeof product !== 'object') return '';
  const short = ikeaCatalogSubtitle(product);
  if (short) return short;
  const name = String(product.name || '').trim();
  const alt = product.imageAlt;
  if (typeof alt === 'string' && name && alt.length > name.length + 1) {
    return alt.slice(name.length + 1).trim();
  }
  return name || String(alt || '').trim();
}
